
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { User } from "@supabase/supabase-js";
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "./ProfileForm";
import { useProfile } from "@/hooks/useProfile";
import { BookOpenCheck, FileUser } from "lucide-react";
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

interface AccreditedToggleProps {
  form: UseFormReturn<ProfileFormData>;
  user: User;
}

export function AccreditedToggle({ form, user }: AccreditedToggleProps) {
  const { updateProfile } = useProfile(user);
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col justify-between h-full">
      <FormField
        control={form.control}
        name="isAccredited"
        render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between space-y-0 pb-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base font-medium">Accredited Investor</FormLabel>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={async (checked) => {
                updateProfile({ is_accredited: checked });
                field.onChange(checked);
              }}
            />
          </FormControl>
        </FormItem>
        )}
      />
      
      <div className={`flex gap-2 ${isMobile ? 'flex-col' : 'flex-row'}`}>
        <Button 
          type="button" 
          variant="outline" 
          className={`${isMobile ? 'w-full min-h-[44px]' : 'flex-1'}`} 
          asChild
        >
          <Link to="/settings/eligibility">
            <BookOpenCheck className="mr-2 h-4 w-4" />
            Check Eligibility
          </Link>
        </Button>
        
        <Dialog>
          <DialogTrigger asChild>
            <Button 
              type="button" 
              variant="secondary" 
              className={`${isMobile ? 'w-full min-h-[44px]' : 'flex-1'}`}
            >
              <FileUser className="mr-2 h-4 w-4" />
              Investor Profile
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Investor Profile Verification</DialogTitle>
            </DialogHeader>
            <div className="py-4">
              <p className="text-muted-foreground">
                Run KYC Process to verify your investor profile and access additional features.
              </p>
            </div>
            <div className="flex justify-end">
              <Button variant="outline">Cancel</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
